import { render, staticRenderFns } from "./overdueReasonDialog.vue?vue&type=template&id=d48db5bc&scoped=true"
import script from "./overdueReasonDialog.vue?vue&type=script&lang=js"
export * from "./overdueReasonDialog.vue?vue&type=script&lang=js"
import style0 from "./overdueReasonDialog.vue?vue&type=style&index=0&id=d48db5bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48db5bc",
  null
  
)

export default component.exports